<template>
    <VfModal class="m-talk-subscriptions-help" scrolls @click.stop>
        <template #header>About My Numbers &amp; Notifications</template>

        <section>
            <h3><i class="fa-solid fa-star" /> My Numbers</h3>
            <p>
                Starred numbers and extensions make up My Numbers. In Talk, My Numbers is a group in the number switcher, with unread counts across
                all of them, and it's what Talk shows until you pick something else.
            </p>
            <p>
                Starred extensions also show their live calls in the phone dock and are listed first, with a star, under Call From in the dialer,
                where they can place Desk Phone calls.
            </p>
            <p>
                Starring doesn't turn notifications on or off. Your primary extension and its linked number are always included, so their star is
                locked.
            </p>
        </section>

        <section>
            <h3><i class="fa-regular fa-desktop" /> Desktop Browser Notifications</h3>
            <p>
                Sends a browser notification for incoming calls to an extension and for new voicemail, text messages and faxes. It reaches every
                browser where you've allowed ZynoSuite notifications; saving with one turned on asks this browser for permission.
            </p>
        </section>

        <section>
            <h3><i class="fa-regular fa-mobile-vibrate" /> Mobile Notifications</h3>
            <p>
                Sends the same voicemail, text message and fax alerts to the ZynoTalk mobile app. Whether calls to an extension ring the app is set by
                Mobile Calls.
            </p>
        </section>

        <section>
            <h3>Mobile Calls</h3>
            <p>
                Shown for extensions that take calls. It follows Mobile Notifications: it's unavailable until Mobile Notifications is on for that row,
                and with Mobile Notifications off no calls ring the app.
            </p>
            <dl>
                <dt>No Calls</dt>
                <dd>Calls to this extension never ring the app. Other mobile notifications still arrive.</dd>
                <dt>All Calls</dt>
                <dd>Every incoming call for the extension rings the app, including calls that arrive through a ring group.</dd>
                <dt>Direct Calls</dt>
                <dd>Only calls made or transferred directly to the extension ring the app. Ring group calls normally don't.</dd>
            </dl>
        </section>

        <template #footer>
            <button type="button" class="zs-btn" @click="callback()">Close</button>
        </template>
    </VfModal>
</template>

<script lang="ts" setup>
import { VfModal } from '@zyno-io/vue-foundation';

defineProps<{
    callback: () => void;
}>();
</script>

<style scoped>
@reference '#tw.css';

.m-talk-subscriptions-help {
    :deep(.vf-modal-content) {
        @apply max-w-lg space-y-4;
    }

    h3 {
        @apply font-semibold mb-1 flex items-center gap-2;
    }

    p + p {
        @apply mt-2;
    }

    dl {
        @apply mt-2 grid grid-cols-[auto_1fr] gap-x-3 gap-y-1;
    }

    dt {
        @apply font-medium;
    }
}
</style>
